const PROTOCOL_HANDLER_ROUTE_RE = /^protocol-handler___/;

export default defineNuxtRouteMiddleware(async (to) => {
  const error = useError().value;

  if (error?.statusCode === 404 && to.name) {
    clearError();
  }

  if (PROTOCOL_HANDLER_ROUTE_RE.test(to.name?.toString() || '')) {
    return;
  }

  if (/^login___..$/.test(to.name?.toString() || '')) {
    if (localStorage.getItem('refresh_token')) {
      return await navigateTo('/');
    }

    return;
  }

  if (/^admin-set-password___..$/.test(to.name?.toString() || '')) {
    return;
  }

  if (!localStorage.getItem('refresh_token')) {
    return await useLogout({ fullPath: to.fullPath });
  }
});
